/**
 * Sidebar access — subsections of "Conversas" can be restricted per role.
 *
 * Only list subsections that differ from "everyone can see".
 * Keys must match `name` on each child in Sidebar.vue (Conversation group).
 */
export const CONVERSATION_SUBSECTION_ACCESS = {
  All: {
    roles: ['administrator'],
    routes: ['home', 'inbox_conversation'],
  },
  Mentions: {
    roles: ['administrator'],
    routes: ['conversation_mentions', 'conversation_through_mentions'],
  },
  Unattended: {
    roles: ['administrator'],
    routes: ['conversation_unattended', 'conversation_through_unattended'],
  },
};

const routeToSubsection = Object.fromEntries(
  Object.entries(CONVERSATION_SUBSECTION_ACCESS).flatMap(
    ([subsection, { routes = [] }]) => routes.map(r => [r, subsection])
  )
);

/** Top-level sidebar items (future use). Omit = all roles. */
export const SIDEBAR_ACCESS = {};

export const canAccessSidebarItem = (itemName, userRole) => {
  const config = SIDEBAR_ACCESS[itemName];
  if (!config?.roles) return true;
  return config.roles.includes(userRole);
};

export const canAccessConversationSubsection = (subsectionName, userRole) => {
  const config = CONVERSATION_SUBSECTION_ACCESS[subsectionName];
  if (!config) return true;
  return config.roles.includes(userRole);
};

export const canAccessRoute = (routeName, userRole) => {
  const subsection = routeToSubsection[routeName];
  if (!subsection) return true;
  return canAccessConversationSubsection(subsection, userRole);
};
